<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card>
        <div class="pa-4">
          <div class="d-flex justify-space-between align-center">
            <div class="startdate_sale_statistic mr-1">
              <v-menu ref="menu_start_date" v-model="menu_start_date" :close-on-content-click="false" :return-value.sync="start_date" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="start_date_be" label="วันที่เริ่ม (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="start_date" :max="end_date" no-title scrollable locale="th" :events="dateStartEndBE('start_date')">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="searchDate('start_date')">
                    ตกลง
                  </v-btn>
                  <v-btn text color="primary" @click="menu_start_date = false">
                    ยกเลิก
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>

            <div class="enddate_sale_statistic ml-1">
              <v-menu ref="menu_end_date" v-model="menu_end_date" :close-on-content-click="false" :return-value.sync="end_date" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="end_date_be" label="วันที่สิ้นสุด (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="end_date" :min="start_date" no-title scrollable locale="th" :events="dateStartEndBE('end_date')">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="searchDate('end_date')">
                    ตกลง
                  </v-btn>
                  <v-btn text color="primary" @click="menu_end_date = false">
                    ยกเลิก
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </div>
          <div class="col-12 d-flex justify-center">
            <v-btn color="#1094C7" class="white--text titlefont_poslist mx-2" type="submit" height="50" @click="exportPDF">
              ดาวน์โหลดรายงาน ไฟล์ PDF
            </v-btn>

            <v-btn color="#28ab28" class="white--text titlefont_poslist mx-2" type="submit" height="50" @click="exportExcel">
              ดาวน์โหลดรายงาน ไฟล์ Excel
            </v-btn>
          </div>
        </div>
        <v-card-title>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="data" :search="search">
          <template v-slot:item="dataDetail">
            <tr v-if="$props.title != 'food_cancel'">
              <td>{{dataDetail.item.number}}</td>
              <td>{{dataDetail.item.name}}</td>
              <td>{{dataDetail.item.type}}</td>
              <td>{{dataDetail.item.sale}}</td>
            </tr>
            <tr v-if="$props.title == 'food_cancel'">
              <td>{{dataDetail.item.created_at}}</td>
              <td>{{dataDetail.item.food_and_topping}}</td>
              <td>{{dataDetail.item.total_price}}</td>
              <td>{{dataDetail.item.invoice_code}}</td>
              <td>{{dataDetail.item.note}}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <NotFoundDialog v-model="dialogVisible" @retry="clearSearch"/>
  </div>
</template>

<script>
import {
  HTTP
} from "@/axios.js"
import NotFoundDialog from "@/components/menuadmin/NotFoundDialog.vue";
export default {
  props: ['title'],
  components: {
        NotFoundDialog,
    },
  data() {
    return {
      loading_page: true,
      menu_start_date: false,
      menu_end_date: false,
      start_date_be: '',
      start_date: '',
      end_date_be: '',
      end_date: '',
      search: '',
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          filterable: false,
          value: 'number',
        },
        {
          text: 'ชื่ออาหาร',
          value: 'name'
        },
        {
          text: 'ประเภท',
          value: 'type'
        },
        {
          text: 'ยอดขาย',
          value: 'sale'
        },
      ],
      data: [],
      dialogVisible:false
    }
  },
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  methods: {
    async page_cancel() {
      if (this.$props.title === 'food_cancel') {
        this.headers = [
          {
            text: 'วันที่/เวลา',
            align: 'start',
            filterable: false,
            value: 'created_at',
          },
          {
            text: 'ชื่ออาหาร/ท้อปปิ้ง',
            value: 'food_and_topping'
          },
          {
            text: 'มูลค่า',
            value: 'total_price'
          },
          {
            text: 'เลขที่ใบเสร็จ',
            value: 'invoice_code'
          },
          {
            text: 'หมายเหตุ',
            value: 'note'
          },
        ]
      } else {
        this.headers = [
          {
            text: 'ลำดับ',
            align: 'start',
            filterable: false,
            value: 'number',
          },
          {
            text: 'ชื่ออาหาร',
            value: 'name'
          },
          {
            text: 'ประเภท',
            value: 'type'
          },
          {
            text: 'ยอดขาย',
            value: 'sale'
          },
        ]
      }
    },
    async dateDefault() {
      const dateResult = new Date().getDate() > 9 ? new Date().getDate().toString() : `0${new Date().getDate().toString()}`
      const mResult = new Date().getMonth() + 1
      const monthResult = mResult > 9 ? mResult.toString() : `0${mResult.toString()}`
      this.start_date = new Date().getFullYear() + '-' + monthResult + '-' + dateResult
      this.end_date = new Date().getFullYear() + '-' + monthResult + '-' + dateResult
    },
    dateStartEndBE(type) {
      if (type == 'start_date') {
        if (this.start_date == '') {
          this.start_date_be = ''
        }
        if (this.start_date) {
          let date_arr = this.start_date.split('-')
          let year = parseInt(date_arr[0]) + 543
          let month = parseInt(date_arr[1]) - 1
          month = this.$store.state.monthList[month].name_short
          this.start_date_be = `${date_arr[2]}/${month}/${year}`
        }
      }
      if (type == 'end_date') {
        if (this.end_date == '') {
          this.end_date_be = ''
        }
        if (this.end_date) {
          let date_arr = this.end_date.split('-')
          let year = parseInt(date_arr[0]) + 543
          let month = parseInt(date_arr[1]) - 1
          month = this.$store.state.monthList[month].name_short
          this.end_date_be = `${date_arr[2]}/${month}/${year}`
        }
      }
    },
    async searchDate(type) {
      if (type == 'start_date') {
        this.$refs.menu_start_date.save(this.start_date)
        let date_arr = this.start_date.split('-')
        let year = parseInt(date_arr[0]) + 543
        let month = parseInt(date_arr[1]) - 1
        month = this.$store.state.monthList[month].name_short
        this.start_date_be = `${date_arr[2]}/${month}/${year}`
        this.menu_start_date = false
      }
      if (type == 'end_date') {
        this.$refs.menu_end_date.save(this.end_date)
        let date_arr = this.end_date.split('-')
        let year = parseInt(date_arr[0]) + 543
        let month = parseInt(date_arr[1]) - 1
        month = this.$store.state.monthList[month].name_short
        this.end_date_be = `${date_arr[2]}/${month}/${year}`
        this.menu_end_date = false
      }
      if (this.start_date && this.end_date) {
        if (this.$props.title === 'food') {
          this.foodList()
        }
        if (this.$props.title === 'topping') {
          this.toppingList()
        }
        if (this.$props.title === 'food_cancel') {
          this.foodCancelList()
        }

      }
    },
    async foodList() {
      this.loading_page = true
      this.data = []
      HTTP.get('/top_food?first_date=' + this.start_date + '&end_date=' + this.end_date, {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
          .then((response) => {
            if (response.data.successful === true) {
              let number = 1
              response.data.food.forEach(detail => {
                this.data.push({
                  number: number,
                  name: detail.foodName,
                  type: detail.categoryName,
                  sale: detail.sum_amount,
                })
                number += 1
              })
              this.loading_page = false
            }

          }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    async toppingList() {
      this.loading_page = true
      this.data = []
      HTTP.get('/top_topping?first_date=' + this.start_date + '&end_date=' + this.end_date, {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
          .then((response) => {
            if (response.data.successful === true) {
              let number = 1
              response.data.food.forEach(detail => {
                this.data.push({
                  number: number,
                  name: detail.topingName,
                  type: detail.categoryName,
                  sale: detail.sum_amount,
                })
                number += 1
              })
              this.loading_page = false
            }

          }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    async foodCancelList() {
      this.loading_page = true
      this.data = []
      HTTP.get('/POS/not_return_log?first_date=' + this.start_date + '&end_date=' + this.end_date, {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
          .then((response) => {
            if (response.data.successful === true) {
              response.data.list.forEach(detail => {
                this.data.push({
                  created_at: detail.created_at,
                  food_and_topping: detail.food_and_topping,
                  total_price: detail.total_price,
                  invoice_code: detail.invoicn_code,
                  note: detail.not,
                })
              })
              this.loading_page = false
            }

          }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    async exportExcel() {
      if (this.$props.title === 'food') {
        this.downloadFile('/POS/export-top-food-excel','top_food.xlsx')
        }
        if (this.$props.title === 'topping') {
          this.downloadFile('/POS/export-top-topping-excel','top_topping.xlsx')
        }
        if(this.$props.title === 'food_cancel'){
          this.downloadFile('/POS/export-food-cancel-excel','top_food.xlsx')
        }
    },
    async exportPDF() {
      if (this.$props.title === 'food') {
        this.downloadFile('/POS/export-top-food-pdf','top_food.pdf')
        }
        if (this.$props.title === 'topping') {      
          this.downloadFile('/POS/export-top-topping-pdf','top_topping.pdf')
        }
        if(this.$props.title === 'food_cancel'){
          this.downloadFile('/POS/export-food-cancel-pdf','top_food.pdf')
        }
    },
    downloadFile(url,fileName){
      HTTP.post(url, {date_start:this.start_date,date_end:this.end_date},{
      headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
      },
      responseType: 'blob'
      })
      .then((response) => {
      if (response.status == 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.setAttribute('download', fileName);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
      }

      })
      .catch((error) => {
      if(error.response.status === 404){
        this.dialogVisible = true;
      }
      if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
      }
      })
    },
    clearSearch(is_retry){            
      if(is_retry){
        this.dialogVisible = false
        this.start_date = ''
        this.end_date = ''
        if (this.$props.title === 'food') {
          this.foodList()
        }
        if (this.$props.title === 'topping') {
          this.toppingList()
        }
        if (this.$props.title === 'food_cancel') {
          this.foodCancelList()
        }
      }
    }
  },
  created() {
    this.dateDefault()
  },
  mounted() {
    this.foodList()
  },
  watch: {
    title: function (newVal) {
      this.dateDefault()
      if (newVal === 'food') {
        this.foodList()
        this.page_cancel()
      }
      if (newVal === 'topping') {
        this.toppingList()
        this.page_cancel()
      }
      if (newVal === 'food_cancel') {
        this.foodCancelList()
        this.page_cancel()
      }
    },
  }
}
</script>
